$('.worko-tabs .col-tabs .tab').click(function(){
	let self = $(this);
	self.parents('.col-tabs').find('.tab').removeClass('active');
	self.addClass('active');
});
